// @ts-nocheck 2ae43033
import * as selectors from './applyModeFromClipboardSelectors';

export { selectors };
